module.exports = __webpack_public_path__ + "static/media/logo.dbe06078.png";